import { Routes, Route, Navigate } from 'react-router-dom';
import AppShell from './components/layout/AppShell';
import RequireAuth from './components/layout/RequireAuth';
import Login from './pages/Login';
import Signup from './pages/Signup';
import AcceptInvite from './pages/AcceptInvite';
import Portal from './pages/Portal';
import SignerPage from './pages/Sign';
import Dashboard from './pages/Dashboard';
import Onboarding from './pages/Onboarding';
import MattersList from './pages/Matters/List';
import MatterNew from './pages/Matters/New';
import MatterDetail from './pages/Matters/Detail';
import Diary from './pages/Diary';
import Tasks from './pages/Tasks';
import Parties from './pages/Parties';
import Attorneys from './pages/Attorneys';
import Invoices from './pages/Invoices';
import InvoiceDetail from './pages/InvoiceDetail';
import FeeBook from './pages/FeeBook';
import Trust from './pages/Trust';
import Documents from './pages/Documents';
import Precedents from './pages/Precedents';
import Signing from './pages/Signing';
import SettingsLayout from './pages/Settings/Layout';
import SettingsChambers from './pages/Settings/Chambers';
import SettingsMembers from './pages/Settings/Members';
import SettingsPermissions from './pages/Settings/Permissions';
import SettingsRates from './pages/Settings/Rates';
import SettingsCourts from './pages/Settings/Courts';
import SettingsCourtCalendar from './pages/Settings/CourtCalendar';
import SettingsSmtp from './pages/Settings/Integrations/SMTP';
import SettingsAI from './pages/Settings/Integrations/AI';
import SettingsAIAudit from './pages/Settings/AIAudit';
import SettingsXero from './pages/Settings/Integrations/Xero';
import SettingsCalendar from './pages/Settings/Integrations/Calendar';
import SettingsBankImports from './pages/Settings/BankImports';
import SettingsBilling from './pages/Settings/Billing';
import SettingsCompliance from './pages/Settings/Compliance';
import SettingsProfile from './pages/Settings/Profile';
import PlatformTenants from './pages/PlatformAdmin/Tenants';
import PlatformPlans from './pages/PlatformAdmin/Plans';

// Router basename is "/app", so all route paths here are relative to it.
// e.g. "/matters" matches URL /app/matters.
export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/accept-invite" element={<AcceptInvite />} />
      <Route path="/portal" element={<Portal />} />
      <Route path="/sign" element={<SignerPage />} />

      <Route element={<RequireAuth><AppShell /></RequireAuth>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/onboarding" element={<Onboarding />} />

        <Route path="/matters" element={<MattersList />} />
        <Route path="/matters/new" element={<MatterNew />} />
        <Route path="/matters/:id/*" element={<MatterDetail />} />

        <Route path="/diary" element={<Diary />} />
        <Route path="/tasks" element={<Tasks />} />
        <Route path="/parties" element={<Parties />} />
        <Route path="/attorneys" element={<Attorneys />} />

        <Route path="/invoices" element={<Invoices />} />
        <Route path="/invoices/:id" element={<InvoiceDetail />} />
        <Route path="/fee-book" element={<FeeBook />} />
        <Route path="/trust" element={<Trust />} />
        <Route path="/documents" element={<Documents />} />
        <Route path="/precedents" element={<Precedents />} />
        <Route path="/signing" element={<Signing />} />

        <Route path="/settings" element={<SettingsLayout />}>
          <Route index element={<Navigate to="chambers" replace />} />
          <Route path="chambers"           element={<SettingsChambers />} />
          <Route path="profile"            element={<SettingsProfile />} />
          <Route path="members"            element={<SettingsMembers />} />
          <Route path="permissions"        element={<SettingsPermissions />} />
          <Route path="rates"              element={<SettingsRates />} />
          <Route path="courts"             element={<SettingsCourts />} />
          <Route path="court-calendar"     element={<SettingsCourtCalendar />} />
          <Route path="integrations/ai"    element={<SettingsAI />} />
          <Route path="ai-audit"           element={<SettingsAIAudit />} />
          <Route path="integrations/smtp"  element={<SettingsSmtp />} />
          <Route path="integrations/xero"  element={<SettingsXero />} />
          <Route path="integrations/calendar" element={<SettingsCalendar />} />
          <Route path="bank-imports"       element={<SettingsBankImports />} />
          <Route path="billing"            element={<SettingsBilling />} />
          <Route path="compliance"         element={<SettingsCompliance />} />
        </Route>

        <Route path="/platform-admin" element={<PlatformTenants />} />
        <Route path="/platform-admin/plans" element={<PlatformPlans />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
